import AOS from 'aos';

export default function() {
  AOS.init();
}
